// btw-front/src/api/partnerSignup.js
import { api } from "./client";

export async function checkBusinessNumber(bn) {
  const params = new URLSearchParams({ bn }).toString();
  return api.get(`/partner/signup/check-business-number?${params}`);
}

// 로그인 ID 사용 가능 여부 — { available, reason? }
export async function checkLoginId(id) {
  const params = new URLSearchParams({ id }).toString();
  return api.get(`/partner/signup/check-login-id?${params}`);
}

// payload = JSON 본문, files = { brochure?, businessRegistration?, bankbook? } 각 File | null
export async function create(payload, files) {
  const fd = new FormData();
  // data 는 텍스트 필드 — Blob 으로 넣으면 multer 가 "파일" 로 인식해
  // Unexpected field 에러로 떨어진다. 반드시 string 으로 append.
  fd.append("data", JSON.stringify(payload));
  if (files && files.brochure) fd.append("brochure", files.brochure);
  if (files && files.businessRegistration)
    fd.append("businessRegistration", files.businessRegistration);
  if (files && files.bankbook) fd.append("bankbook", files.bankbook);
  return api.postForm("/partner/signup", fd);
}

// 기존 회사 가입용 회사명 검색 — 활성 회사만, { items: [{ id, companyName, representativeName }] }
// 2자 미만이면 서버가 400 을 주므로 호출부에서 먼저 거른다.
export async function searchCompanies(q) {
  const params = new URLSearchParams({ q }).toString();
  const res = await api.get(`/partner/signup/companies?${params}`);
  return (res && res.items) || [];
}
